import React from 'react'
import { useParams } from 'react-router-dom'
import ManageLightspeed from './ManageLightspeed'
import ManageShipday from './ManageShipday'
import LocationPage from './ManageLightspeed/LocationPage'
import { PARTNER_SLUGS } from '../constants'

export const ManageIntegrations = () => {
  const { slug, storeId } = useParams()

  if (slug === PARTNER_SLUGS.LIGHTSPEED) {
    if (storeId) {
      return <LocationPage />
    }

    return <ManageLightspeed />
  }

  if (slug === PARTNER_SLUGS.SHIPDAY) {
    return <ManageShipday />
  }

  return <></>
}

export default ManageIntegrations
